export { default } from './TidalRateLabel'
